// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                       from 'firebase/functions';

// ===== Interfaces =====

import {
    IPostCollabDocPublishTargetState,
}                                       from '../interfaces';

const getPostCollaborativePublishTargetState = async ({
    test,
    docId,
}: {
    test: boolean,
    docId: string,
}): Promise<IPostCollabDocPublishTargetState> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        Record<string, boolean | string>,
        IPostCollabDocPublishTargetState
    >(
        functions,
        'getPostCollaborativePublishTargetState',
    );
    return callable({
        test,
        docId,
    }).then((result) => result.data as IPostCollabDocPublishTargetState).catch((err) => {
        throw err;
    });
};

export default getPostCollaborativePublishTargetState;
